var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalcFigureVolumeTube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 250,
    height: 250,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artboard11"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.22837e-17,0.853857,-0.245851,1.5054e-17,100.38,46.9458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.439,106.4L27.439,121.324L15.98,101.425L27.439,81.527L27.439,96.451L155.973,96.451L155.973,81.527L167.431,101.425L155.973,121.324L155.973,106.4L27.439,106.4Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.711857,-1.2326e-32,0,0.245851,73.6972,7.62229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.725,106.4L29.725,121.324L15.98,101.425L29.725,81.527L29.725,96.451L153.687,96.451L153.687,81.527L167.431,101.425L153.687,121.324L153.687,106.4L29.725,106.4Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.447187,-1.2326e-32,0,0.245851,98.9904,192.738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.859,106.4L37.859,121.324L15.98,101.425L37.859,81.527L37.859,96.451L145.552,96.451L145.552,81.527L167.431,101.425L145.552,121.324L145.552,106.4L37.859,106.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,-20.4822,92.8338)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "h")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,53.006,-10.5166)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "Do")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,54.9834,202.29)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "Di")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,14.9654,90.0968)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "V")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17474,0,0,1,-18.5695,35.9082)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135,
    cy: 147.5,
    rx: 45,
    ry: 22.5,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "3.67px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17474,0,0,1,-18.5695,-81.7556)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135,
    cy: 147.5,
    rx: 45,
    ry: 22.5,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "3.67px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.752522,0,0,0.640584,38.4305,-28.7416)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135,
    cy: 147.5,
    rx: 45,
    ry: 22.5,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "5.72px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.752522,0,0,0.640584,38.4305,88.0717)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135,
    cy: 147.5,
    rx: 45,
    ry: 22.5,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "5.72px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-9.44758,-17.4422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.605,200.85L115.605,83.187",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,58.2794,-19.4608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.605,200.85L115.605,83.187",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.0209505,5.90821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.137,177.5L87.137,60",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,105.748,7.15821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.137,177.5L87.137,60",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 4
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcFigureVolumeTube);
export default __webpack_public_path__ + "static/media/calc-figure-volume-tube.f2af41d02139b7bac3543a1580abf4d9.svg";
export { ForwardRef as ReactComponent };